import { useDrag } from "react-dnd";
import "./Maya.css";

/*
This class implements a maya image that can be dragged.
Parts of it were created with the help of LLMs.
*/
export function Maya({ id, mayaImage, isCorn, itemSize }) {
  const [{ isDragging }, drag] = useDrag({
    type: "maya",
    item: { id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });
  
  return (
    <div
      ref={drag}
      className="maya-object"
      style={{
        opacity: isDragging ? 0.5 : 1
      }}
    >
      <img
        src={mayaImage}
        alt="maya-image"
        style={{
          width: isCorn ? itemSize+"dvh" : 4*itemSize+"dvh", // If not corn, stretch it.
          height: itemSize+"dvh",
          filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))",
        }}
      />
    </div>
  );
}

/*
This class implements a maya image that can be dragged.
Parts of it were created with the help of LLMs.
*/
export function MayaOrigin({ id, mayaImage, isCorn, itemSize }) {
  const [{ isDragging }, drag] = useDrag({
    type: "maya-origin",
    item: { id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });
  
  return (
    <div
      ref={drag}
      className="maya-object"
      style={{
        opacity: isDragging ? 0.5 : 1
      }}
    >
      <img
        src={mayaImage}
        alt="maya-image"
        style={{
          width: isCorn ? itemSize+"dvh" : 4*itemSize+"dvh", // If not corn, stretch it.
          height: itemSize+"dvh",
          filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))",
        }}
      />
    </div>
  );
}

/*
This class implements a maya image that can be dragged.
Parts of it were created with the help of LLMs.
*/
export function MayaDestination({ id, mayaImage, isCorn, itemSize }) {
  const [{ isDragging }, drag] = useDrag({
    type: "maya-destination",
    item: { id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });
  
  return (
    <div
      ref={drag}
      className="maya-object"
      style={{
        opacity: isDragging ? 0.5 : 1
      }}
    >
      <img
        src={mayaImage}
        alt="maya-image"
        style={{
          width: isCorn ? itemSize+"dvh" : 4*itemSize+"dvh", // If not corn, stretch it.
          height: itemSize+"dvh",
          filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))",
        }}
      />
    </div>
  );
}
